<template>
  <div class="sky-poc-project-view" v-show="isShow">
    <!-- <toolbar-panel></toolbar-panel> -->
    <content-panel
      :projectId="projectId"
      :stage="flowStatus"
      :createBytmp="createBytmp"
      :createByTmpNotBackToFirstStep="createByTmpNotBackToFirstStep"
      :industryId="industryId"
      :industryCode="industryCode"
      :customer="customer"
    ></content-panel>
  </div>
</template>
<script>
import viewController from 'sky-engine/views/viewController'

import contentPanel from './contentPanel'
// import toolbarPanel from './toolbarPanel'

export default {
  name: 'PocProjectDetail',
  inject: ['PocDetail'],
  components: {
    // toolbarPanel,
    contentPanel
  },
  extends: viewController,
  props: {
    views: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      projectId: this.PocDetail.views.params.projectId,
      customer: this.PocDetail.views.params.customer,
      industryCode: this.PocDetail.views.params.industryCode,
      flowStatus: this.PocDetail.views.params.flowStatus,
      industryId: this.PocDetail.views.params.industryId,
      createBytmp: this.PocDetail.views.params.createBytmp,
      createByTmpNotBackToFirstStep: this.PocDetail.views.params.createByTmpNotBackToFirstStep
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/mixin/mixin';
@import '~sky-engine/assets/styles/common/var.scss';
@include b(poc-project-view) {
  height: 100%;
}
</style>
